import * as React from "react";
import * as symbols from "../SymbolsGL";
import { GrafosSymbol } from "../interfaces/element";
import { WebGLContext } from "../CanvasGL";
import { hexToRgbA } from "../CanvasGL/utils";
import { v4 as uuid } from "uuid";
import { useAttributes, useShaders } from "../CanvasGL/hooks";
import { useEffect, useMemo } from "react";
export const ScatterGL = (props) => {
    const id = React.useRef(uuid());
    const { thickness, domainX, domainY, color, show, symbol } = props;
    const { canvas, scatterShaders, requestUpdate } = React.useContext(WebGLContext);
    const { shaderProgram } = useShaders(canvas, scatterShaders.vertexShader, scatterShaders.fragmentShader);
    const { xy } = props;
    const attributes = useMemo(() => [
        {
            name: "aVertexPosition",
            index: 2,
            buffer: canvas.createBuffer(),
            values: new Float32Array(xy),
        },
    ], [xy]);
    const items = xy.length / 2;
    useAttributes(canvas, shaderProgram, attributes, items, id.current, canvas.POINTS);
    useUniforms(canvas, shaderProgram, thickness, domainX, domainY, color, show, symbol, requestUpdate);
    return null;
};
export const useUniforms = (gl, shaderProgram, thickness = 6, domainX = [0, 1], domainY = [0, 1], color = "#000", show = true, symbol = GrafosSymbol.circle, requestUpdate) => {
    const texture = useMemo(() => {
        if (!shaderProgram)
            return;
        return generateSymbolTexture(gl, shaderProgram, symbol);
    }, [gl, shaderProgram, symbol]);
    useEffect(() => {
        if (!shaderProgram || !texture)
            return;
        const rgbaColor = hexToRgbA(color);
        gl.useProgram(shaderProgram);
        const pUniformDomain = gl.getUniformLocation(shaderProgram, "uDomainX");
        gl.uniform2fv(pUniformDomain, domainX);
        const pUniformDomainY = gl.getUniformLocation(shaderProgram, "uDomainY");
        gl.uniform2fv(pUniformDomainY, domainY);
        const pUniformColor = gl.getUniformLocation(shaderProgram, "uColor");
        gl.uniform4fv(pUniformColor, rgbaColor);
        const pUniformThickness = gl.getUniformLocation(shaderProgram, "uThickness");
        gl.uniform1f(pUniformThickness, thickness);
        const pUniformShow = gl.getUniformLocation(shaderProgram, "uShowPoint");
        gl.uniform1f(pUniformShow, show ? 1 : 0);
        loadTexture(gl, shaderProgram, texture);
        requestUpdate();
    }, [gl, shaderProgram, show, domainX, domainY, color, symbol]);
};
function loadTexture(gl, shaderProgram, texture) {
    const uSampler = gl.getUniformLocation(shaderProgram, "uSampler");
    gl.activeTexture(gl.TEXTURE0);
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.uniform1i(uSampler, 0);
}
export function generateSymbolTexture(gl, shaderProgram, symbol) {
    gl.useProgram(shaderProgram);
    const texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
    const level = 0;
    const internalFormat = gl.RGBA;
    const width = 16;
    const height = 16;
    const border = 0;
    const srcFormat = gl.RGBA;
    const srcType = gl.UNSIGNED_BYTE;
    const image = symbols[symbol];
    gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, width, height, border, srcFormat, srcType, image);
    gl.generateMipmap(gl.TEXTURE_2D);
    return texture;
}
//# sourceMappingURL=index.js.map